import * as z from "zod";
//#region src/__generated__/internal/monitoring/zod/monitoringRequestItemSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const monitoringRequestItemSchema = z.object({
	debtAmount: z.number().nullish(),
	id: z.uuid().nullish(),
	invoiceAmount: z.number().nullish(),
	number: z.int().nullish(),
	paymentAmount: z.number().nullish(),
	railway: z.enum([
		"VOSTOCHNO_SIBIRSKAYA",
		"GORKOVSKAYA",
		"DALNEVOSTOCHNAYA",
		"ZABAYKALSKAYA",
		"ZAPADNO_SIBIRSKAYA",
		"KALININGRADSKAYA",
		"KRASNOYARSKAYA",
		"KUYBYSHEVSKAYA",
		"MOSKOVSKAYA",
		"OKTYABRSKAYA",
		"PRIVOLZHSKAYA",
		"SVERDLOVSKAYA",
		"SEVERNAYA",
		"SEVERO_KAVKAZSKAYA",
		"YUGO_VOSTOCHNAYA",
		"YUZHNO_URALSKAYA"
	]).optional().describe("Железная дорога (филиал ОАО \"РЖД\")"),
	remainingDays: z.int().nullish(),
	title: z.string().nullish()
});
//#endregion
//#region src/__generated__/internal/monitoring/zod/pageResponseMonitoringRequestItemSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pageResponseMonitoringRequestItemSchema = z.object({
	content: z.array(monitoringRequestItemSchema).nullish().describe("Элементы страницы"),
	page: z.int().nullish().describe("Номер текущей страницы (0-based)").meta({ examples: [0] }),
	size: z.int().nullish().describe("Размер страницы").meta({ examples: [20] }),
	totalElements: z.int().nullish().describe("Общее количество элементов").meta({ examples: [142] }),
	totalPages: z.int().nullish().describe("Общее количество страниц").meta({ examples: [8] })
}).describe("Пагинированный ответ");
//#endregion
//#region src/__generated__/internal/monitoring/zod/detailsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const detailsQueryMetricSchema = z.enum([
	"TOTAL",
	"ACTIVE",
	"TU_ISSUED",
	"REJECTED",
	"PAID_SERVICE",
	"FREE_SERVICE",
	"INVOICE_TOTAL",
	"PAYMENT_TOTAL",
	"DEBT_TOTAL",
	"ACTIVE_PLANNED",
	"ACTIVE_APPROACHING",
	"ACTIVE_AT_RISK",
	"ACTIVE_OVERDUE",
	"ACTIVE_PAID_SERVICE",
	"ACTIVE_FREE_SERVICE",
	"ACTIVE_UNDEFINED_PAYMENT",
	"ACTIVE_AWAITING_INVOICE",
	"ACTIVE_AWAITING_PAYMENT",
	"ACTIVE_PAID",
	"ACTIVE_INVOICE_TOTAL",
	"ACTIVE_PAYMENT_TOTAL",
	"ACTIVE_DEBT_TOTAL"
]);
const detailsQueryRailwaySchema = z.array(z.enum([
	"VOSTOCHNO_SIBIRSKAYA",
	"GORKOVSKAYA",
	"DALNEVOSTOCHNAYA",
	"ZABAYKALSKAYA",
	"ZAPADNO_SIBIRSKAYA",
	"KALININGRADSKAYA",
	"KRASNOYARSKAYA",
	"KUYBYSHEVSKAYA",
	"MOSKOVSKAYA",
	"OKTYABRSKAYA",
	"PRIVOLZHSKAYA",
	"SVERDLOVSKAYA",
	"SEVERNAYA",
	"SEVERO_KAVKAZSKAYA",
	"YUGO_VOSTOCHNAYA",
	"YUZHNO_URALSKAYA"
])).optional();
const detailsQueryPageSchema = z.int().optional();
const detailsQuerySizeSchema = z.int().optional();
const detailsStatus200Schema = pageResponseMonitoringRequestItemSchema.describe("Пагинированный ответ");
const detailsResponseSchema = detailsStatus200Schema;
//#endregion
//#region src/__generated__/internal/monitoring/zod/exportSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const exportQueryRailwaySchema = z.array(z.enum([
	"VOSTOCHNO_SIBIRSKAYA",
	"GORKOVSKAYA",
	"DALNEVOSTOCHNAYA",
	"ZABAYKALSKAYA",
	"ZAPADNO_SIBIRSKAYA",
	"KALININGRADSKAYA",
	"KRASNOYARSKAYA",
	"KUYBYSHEVSKAYA",
	"MOSKOVSKAYA",
	"OKTYABRSKAYA",
	"PRIVOLZHSKAYA",
	"SVERDLOVSKAYA",
	"SEVERNAYA",
	"SEVERO_KAVKAZSKAYA",
	"YUGO_VOSTOCHNAYA",
	"YUZHNO_URALSKAYA"
])).optional();
const exportStatus200Schema = z.instanceof(File);
const exportResponseSchema = exportStatus200Schema;
//#endregion
//#region src/__generated__/internal/monitoring/zod/indicatorSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const indicatorSchema = z.object({
	amount: z.number().nullish(),
	percent: z.number().nullish(),
	requestCount: z.int().nullish()
});
//#endregion
//#region src/__generated__/internal/monitoring/zod/roadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const roadSchema = z.object({
	active: z.int().nullish(),
	activePercent: z.number().nullish(),
	name: z.string().nullish(),
	railway: z.enum([
		"VOSTOCHNO_SIBIRSKAYA",
		"GORKOVSKAYA",
		"DALNEVOSTOCHNAYA",
		"ZABAYKALSKAYA",
		"ZAPADNO_SIBIRSKAYA",
		"KALININGRADSKAYA",
		"KRASNOYARSKAYA",
		"KUYBYSHEVSKAYA",
		"MOSKOVSKAYA",
		"OKTYABRSKAYA",
		"PRIVOLZHSKAYA",
		"SVERDLOVSKAYA",
		"SEVERNAYA",
		"SEVERO_KAVKAZSKAYA",
		"YUGO_VOSTOCHNAYA",
		"YUZHNO_URALSKAYA"
	]).optional().describe("Железная дорога (филиал ОАО \"РЖД\")"),
	total: z.int().nullish(),
	totalPercent: z.number().nullish()
});
//#endregion
//#region src/__generated__/internal/monitoring/zod/monitoringResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const monitoringResponseSchema = z.object({
	calculatedAt: z.iso.datetime().nullish(),
	indicators: z.object({}).catchall(indicatorSchema).nullish(),
	reviewPeriodWorkingDays: z.int().nullish(),
	roads: z.array(roadSchema).nullish()
});
//#endregion
//#region src/__generated__/internal/monitoring/zod/summarySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const summaryQueryRailwaySchema = z.array(z.enum([
	"VOSTOCHNO_SIBIRSKAYA",
	"GORKOVSKAYA",
	"DALNEVOSTOCHNAYA",
	"ZABAYKALSKAYA",
	"ZAPADNO_SIBIRSKAYA",
	"KALININGRADSKAYA",
	"KRASNOYARSKAYA",
	"KUYBYSHEVSKAYA",
	"MOSKOVSKAYA",
	"OKTYABRSKAYA",
	"PRIVOLZHSKAYA",
	"SVERDLOVSKAYA",
	"SEVERNAYA",
	"SEVERO_KAVKAZSKAYA",
	"YUGO_VOSTOCHNAYA",
	"YUZHNO_URALSKAYA"
])).optional();
const summaryStatus200Schema = monitoringResponseSchema;
const summaryResponseSchema = summaryStatus200Schema;
//#endregion
export { monitoringRequestItemSchema as _, roadSchema as a, exportResponseSchema as c, detailsQueryPageSchema as d, detailsQueryRailwaySchema as f, pageResponseMonitoringRequestItemSchema as g, detailsStatus200Schema as h, monitoringResponseSchema as i, exportStatus200Schema as l, detailsResponseSchema as m, summaryResponseSchema as n, indicatorSchema as o, detailsQuerySizeSchema as p, summaryStatus200Schema as r, exportQueryRailwaySchema as s, summaryQueryRailwaySchema as t, detailsQueryMetricSchema as u };

//# sourceMappingURL=summarySchema.js.map